import React from 'react';
import { Link } from 'react-router-dom';
import ArticleCard from './ArticleCard';
import { CATEGORIES } from '../content/categories';

const normalizeTitle = (value) =>
  String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

const SectionBlock = ({ title, articles = [], mainVariant = 'horizontal', compact = false, dense = false }) => {
  if (!articles.length) return null;

  const [lead, ...rest] = articles;
  const normalizedTitle = normalizeTitle(title);
  const matchedCategory = CATEGORIES.find((category) => normalizeTitle(category.label) === normalizedTitle);
  const seeMoreHref = normalizedTitle === 'a-la-une'
    ? '/a-la-une'
    : matchedCategory
    ? `/categorie/${matchedCategory.slug}`
    : '/';

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4 md:p-5">
      <div className="mb-3 flex items-center justify-between border-b border-slate-200 pb-2">
        <h2 className="text-sm font-black uppercase tracking-widest text-slate-900">{title}</h2>
        <Link to={seeMoreHref} className="text-xs font-semibold text-indigo-600 transition hover:text-indigo-700">
          Voir plus
        </Link>
      </div>

      <ArticleCard article={lead} variant={mainVariant} categoryOverride={title} />
      {!compact &&
        rest.map((item) => (
          <ArticleCard
            key={item.slug}
            article={item}
            variant={dense ? 'denseCompact' : 'compact'}
            categoryOverride={title}
          />
        ))}
      {compact &&
        rest.map((item) => <ArticleCard key={item.slug} article={item} variant="horizontal" categoryOverride={title} />)}
    </section>
  );
};

export default SectionBlock;
